import { MatchingProduct, PriceContainer, SolutionComponent } from '../Types/MatchingProducts.ts';
import { ProductSliderItem, ProductSliderPriceContainer } from '../../ProductSlider/ProductSliderItem.ts';
import { getComponentsForSelectedSolution } from './SelectedSolutionComponents.ts';

const mapPriceContainerForSlider = (
  priceContainer: PriceContainer | null | undefined
): ProductSliderPriceContainer | undefined => {
  if (!priceContainer) return undefined;

  return {
    ProductId: priceContainer.ProductId,
    Price: priceContainer.Price,
    PriceFormatted: priceContainer.PriceFormatted,
    DiscountPrice: priceContainer.DiscountPrice,
    DiscountPriceFormatted: priceContainer.DiscountPriceFormatted,
    MinimumRRP: priceContainer.MinimumRRP,
    DiscountMinimumRRP: priceContainer.DiscountMinimumRRP,
    CurrencyCode: priceContainer.CurrencyCode,
    Save: priceContainer.Save,
  };
};

const mapSolutionComponentsToSliderItems = (components: SolutionComponent[]): ProductSliderItem[] => {
  return components.map((component) => ({
    productId: component.ProductId,
    canonical: component.Canonical,
    webTitle1: component.Name,
    webTitle2: component.Webtitle2,
    productName: component.Name,
    url: component.ProductUrl,
    imageUrl: component.ImageUrl ?? undefined,
    imageAlt: component.ImageAlt,
    erpOutdoor: component.ErpOutdoor,
    priceContainer: mapPriceContainerForSlider(component.PriceContainer),
    addToCartButton: component.AddToCartButton
      ? {
          ProductIdsForSolution: component.AddToCartButton.ProductIdsForSolution,
          IsSellable: component.AddToCartButton.IsSellable,
        }
      : undefined,
  }));
};

export const getSolutionSliderItems = (
  solutionComponents: SolutionComponent[] | null,
  matchingProducts: MatchingProduct[] | null,
  selectedSolutionIndex: number
): ProductSliderItem[] => {
  const filtered = getComponentsForSelectedSolution(solutionComponents, matchingProducts, selectedSolutionIndex);
  return mapSolutionComponentsToSliderItems(filtered);
};
